export default "__VITE_ASSET__3xZ61Wrx__"